import { Component, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '../../../../components/button/button.component';
import { IconComponent } from '../../../../components/icon/icon.component';

@Component({
  selector: 'td-wb-joyride-close-button',
  templateUrl: './joyride-close-button.component.html',
  styleUrls: ['./joyride-close-button.component.scss'],
  imports: [TranslatePipe, ButtonComponent, IconComponent]
})
export class JoyrideCloseButtonComponent {
  readonly clicked = output<void>();

  onClick(): void {
    this.clicked.emit();
  }
}
